import ContactsContainer from "../../Componant/Contacts";

const Contacts = () => {
  return (
    <div className="page-body">
      <ContactsContainer />
    </div>
  );
};

export default Contacts;
